/**
 * Quick view (multi-variant) + quick add (single variant) for product cards.
 *
 * Theme integration: patches s-carousel pagination (data-number-of-slides) and s-product
 * (ProductMain) for quick-view markup without editing theme.js.
 */
(function () {
  const SEL = {
    panel: "[js-quick-view-panel]",
    fragment: "#QuickViewFragment",
    triggerOpen: "[js-quick-view-card-trigger]",
  };

  /**
   * Swiper renderCustom receives (swiper, element, element); theme used wrong arity.
   * ProductMain: skip recently viewed + optional sticky + main carousel id suffix for QV.
   */
  function installQuickViewThemePatches() {
    const Carousel = customElements.get("s-carousel");
    if (Carousel && !Carousel.prototype.__qvCarouselPatched) {
      Carousel.prototype.__qvCarouselPatched = true;
      Carousel.prototype.connectedCallback = function qvPatchedCarouselConnectedCallback() {
        var e;
        ((e =
          "hotspot" === this.dataset.carouselType
            ? {
              scrollbar: !0,
              loop: !1,
              slidesPerView: 1,
              spaceBetween: 0,
              scrollbar: { el: this.querySelector(this.selectors.hotspotScrollbar), hide: !1, draggable: !0 },
            }
            : "reviews" === this.dataset.carouselType
              ? {
                scrollbar: !0,
                loop: !1,
                slidesPerView: 1,
                spaceBetween: 0,
                scrollbar: { el: this.querySelector(this.selectors.reviewsScrollbar), hide: !1, draggable: !0 },
              }
              : this.dataset.options
                ? JSON.parse(this.dataset.options)
                : {}),
          this._applyPaginationFormatters(e),
          (this.options = Object.assign(this.options, e)),
          void 0 !== this.dataset.numberOfSlides &&
          ((this.options.pagination.type = "custom"),
            (this.options.pagination.renderCustom = function (swiper) {
              var total = swiper && swiper.slides ? swiper.slides.length : 0;
              var current = total ? swiper.realIndex + 1 : 0;
              return ("0" + current).slice(-2) + " / " + ("0" + total).slice(-2);
            })),
          void 0 !== this.dataset.connectedCarousel &&
          ((e = document.querySelector("#" + this.dataset.connectedCarousel)),
            (this.options = Object.assign(this.options, { thumbs: { swiper: e.swiper } }))),
          this._initCarousel());
      };
    }

    const ProductMain = customElements.get("s-product");
    if (!ProductMain || ProductMain.prototype.__qvProductMainPatched) return;
    ProductMain.prototype.__qvProductMainPatched = true;

    const proto = ProductMain.prototype;
    const origRecently = proto._initRecentlyViewed;
    proto._initRecentlyViewed = function () {
      if ("true" === this.dataset.skipRecentlyViewed) return;
      return origRecently.apply(this, arguments);
    };

    const origSticky = proto._initStickyAtc;
    proto._initStickyAtc = function () {
      if (!this.querySelector(this._selectors.sticky)) return;
      return origSticky.apply(this, arguments);
    };

    proto._initZoomModal = function qvPatchedInitZoomModal() {
      this.zoomTriggers = this.querySelectorAll(this._selectors.zoomTrigger);
      if (this.zoomTriggers.length < 1) return;
      this.imageZoomModal = this.querySelector(this._selectors.zoomModal);
      if (!this.imageZoomModal) return;
      var suffix = this.dataset.carouselIdSuffix || "";
      this.mainCarousel = this.querySelector(
        this._selectors.carousel + "#ProductMainImages-" + this.productId + suffix,
      );
      this.modalCarousel = this.imageZoomModal.querySelector(this._selectors.carousel);
      if (!this.modalCarousel) return;
      var self = this;
      this.zoomTriggers.forEach(function (btn) {
        btn.addEventListener("click", self._openImageZoomModal.bind(self));
      });
      if (!(1024 < window.innerWidth) && this.modalCarousel.swiper) {
        this.modalCarousel.swiper.on("realIndexChange", function () {
          self.mainCarousel &&
            self.mainCarousel.swiper &&
            self.mainCarousel.swiper.slideTo(self.modalCarousel.swiper.realIndex);
        });
      }
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", installQuickViewThemePatches);
  } else {
    installQuickViewThemePatches();
  }

  function initYotpoIfPresent() {
    if (typeof yotpoWidgetsContainer !== "undefined" && yotpoWidgetsContainer.initWidgets) {
      try {
        yotpoWidgetsContainer.initWidgets();
      } catch (e) {
        console.warn("Yotpo init", e);
      }
    }
  }

  function reexecuteScripts(container) {
    container.querySelectorAll("script").forEach((oldScript) => {
      if (oldScript.type === "application/json" || oldScript.src) return;
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  async function loadQuickView(productUrl, modal) {
    if (!modal) return;
    if (!modal.dataset.qvClearBound) {
      modal.dataset.qvClearBound = "true";
      modal.addEventListener("close", function () {
        const panel = modal.querySelector(SEL.panel);
        if (panel) panel.innerHTML = "";
      });
    }
    const panel = modal.querySelector(SEL.panel);
    if (!panel) return;

    const cleanUrl = productUrl.split("?")[0];
    const fetchUrl = cleanUrl + "?section_id=quick-view";

    panel.innerHTML =
      '<div class="quick-view-modal__loading" aria-busy="true" aria-live="polite">' +
      '<loading-spinner loading></loading-spinner>' +
      "</div>";
    modal.open();

    try {
      const res = await fetch(fetchUrl, { headers: { Accept: "text/html" } });
      if (!res.ok) throw new Error("HTTP " + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const fragment = doc.querySelector(SEL.fragment);
      if (!fragment) {
        panel.innerHTML = '<p class="text-red text-14 p-xs">Could not load product.</p>';
        return;
      }
      panel.innerHTML = "";
      while (fragment.firstChild) {
        panel.appendChild(fragment.firstChild);
      }
      reexecuteScripts(panel);
      queueMicrotask(() => initYotpoIfPresent());
    } catch (err) {
      console.error(err);
      panel.innerHTML = '<p class="text-red text-14 p-xs">Something went wrong. Please try again.</p>';
    }
  }

  function setProductCardQuickAddBusy(button, busy) {
    if (!button || !button.classList || !button.classList.contains("product-card__quick-view-btn")) return;
    if (busy) {
      button.setAttribute("disabled", "disabled");
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
    } else {
      button.removeAttribute("disabled");
      button.disabled = false;
      button.removeAttribute("aria-busy");
    }
    const sp = button.querySelector("loading-spinner");
    if (sp) {
      if (busy) sp.setAttribute("loading", "");
      else sp.removeAttribute("loading");
    }
  }

  function quickAddToCartWithLimits(variantId, button, isOnSale) {
    if (!variantId) return;
    if (!window.theme || !theme.cartQuantityLimits || typeof theme.cartQuantityLimits.canAddItems !== "function") {
      quickAddToCart(variantId, button);
      return;
    }
    setProductCardQuickAddBusy(button, true);
    window.revealCartLimitBannersOnShopperIntent && window.revealCartLimitBannersOnShopperIntent();
    const cartUrl = (window.routes && window.routes.cart_url) || "/cart";
    fetch(cartUrl + ".js", { credentials: "same-origin" })
      .then((r) => r.json())
      .then((cartData) => {
        const check = theme.cartQuantityLimits.canAddItems(cartData, variantId, 1, isOnSale);
        if (!check.ok) {
          theme.cartQuantityLimits.showDrawerCartError(check.reason);
          setProductCardQuickAddBusy(button, false);
          return;
        }
        theme.cartQuantityLimits.clearDrawerCartError();
        quickAddToCart(variantId, button);
      })
      .catch(() => {
        quickAddToCart(variantId, button);
      });
  }

  function quickAddToCart(variantId, button) {
    if (!variantId) return;
    const cart = document.querySelector("cart-drawer");
    const cartDrawer = document.querySelector("#CartDrawer");
    const addUrl =
      (window.routes && window.routes.cart_add_url) ||
      ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "cart/add.js";
    const sectionIds =
      cart && typeof cart.getSectionsToRender === "function" ? cart.getSectionsToRender().map((e) => e.id) : [];
    setProductCardQuickAddBusy(button, true);
    const payload = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: sectionIds,
      sections_url: window.location.pathname,
    };
    fetch("" + addUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/javascript",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(payload),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data && data.status) {
          if (window.theme && theme.utils && theme.utils.subscriptions && window.PUB_SUB_EVENTS) {
            theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartError, {
              source: "quick-add",
              errors: data.errors || data.description,
              message: data.message,
            });
          }
          throw new Error(typeof data.description === "string" ? data.description : "Cart error");
        }
        if (data && data.errors) {
          throw new Error(typeof data.errors === "string" ? data.errors : JSON.stringify(data.errors));
        }
        if (!cart || typeof cart.renderContents !== "function") {
          window.location.href =
            (window.routes && window.routes.cart_url) || "/cart";
          return;
        }
        if (document.querySelector("cart-items")) document.querySelector("cart-items").onCartUpdate();
        if (document.querySelector("cart-drawer-items")) document.querySelector("cart-drawer-items").onCartUpdate();
        cart.renderContents(data);
        if (window.theme && theme.utils && theme.utils.subscriptions && window.PUB_SUB_EVENTS) {
          theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: "quick-add",
            productVariantId: String(variantId),
          });
        }
        if (cartDrawer && cartDrawer.getAttribute("aria-hidden") === "true" && typeof cartDrawer.open === "function") {
          cartDrawer.open();
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setProductCardQuickAddBusy(button, false);
      });
  }

  /**
   * Reparent modals to <body> so position:fixed is always viewport-relative (avoids
   * transformed ancestors on product grids). Open triggers stay in the card.
   */
  function moveQuickViewModalsToBody() {
    document.querySelectorAll("s-modal.quick-view-modal[data-qv-modal-root]").forEach((modal) => {
      if (modal.dataset.qvPortalDone) return;
      modal.dataset.qvPortalDone = "true";
      document.body.appendChild(modal);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", moveQuickViewModalsToBody);
  } else {
    moveQuickViewModalsToBody();
  }

  const qvPortalRoot =
    document.getElementById("MainContent") ||
    document.getElementById("pageContainer") ||
    document.querySelector("main");
  let qvPortalRaf = false;
  function scheduleMoveQuickViewModalsToBody() {
    if (qvPortalRaf) return;
    qvPortalRaf = true;
    requestAnimationFrame(() => {
      qvPortalRaf = false;
      moveQuickViewModalsToBody();
    });
  }
  if (qvPortalRoot) {
    new MutationObserver(scheduleMoveQuickViewModalsToBody).observe(qvPortalRoot, { childList: true, subtree: true });
  }

  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest(SEL.triggerOpen);
      if (!btn) return;

      const mode = btn.getAttribute("data-quick-view-mode");
      const productUrl = btn.getAttribute("data-product-url");
      const variantId = btn.getAttribute("data-variant-id");

      if (mode === "quick-add") {
        e.preventDefault();
        e.stopPropagation();
        const onSale = btn.getAttribute("data-variant-on-sale") === "true";
        quickAddToCartWithLimits(variantId, btn, onSale);
        return;
      }

      if (mode === "quick-view" && productUrl) {
        e.preventDefault();
        e.stopPropagation();

        const modalId = btn.getAttribute("data-quick-view-modal");
        const modal = modalId ? document.getElementById(modalId) : null;
        if (!modal) {
          console.warn("Quick view: missing modal for id", modalId);
          return;
        }
        loadQuickView(productUrl, modal);
      }
    },
    true,
  );

  /** Family size links (same PDP markup): close quick view first, then full navigation. */
  document.addEventListener(
    "click",
    function (e) {
      const link = e.target.closest("[js-pdp-swatch-link]");
      if (!link || !link.href) return;
      const modal = link.closest("s-modal.quick-view-modal");
      if (!modal || !modal.classList.contains("open")) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

      const url = link.getAttribute("href");
      if (typeof modal.close === "function") modal.close();
      if (url) window.location.assign(url);
    },
    true,
  );
})();